import { Stack } from '@mui/material';
import { useIsDesktop } from 'Hooks';
import { useBankDetailsForm } from 'Hooks/useBankDetailsForm';
import { FormProvider } from 'react-hook-form';
import { Form } from './Form';
import { useContext, useEffect, useRef } from 'react';
import { RequestsContext } from 'Context';
import { IUpdateBankDetails } from 'Interfaces/updateBankDetails';
import { FormActionButtons } from 'Modules/Requests/FormActionButtons';
import { useNavigate } from 'react-router-dom';

interface IBankDetailsForm {
  nextStep: () => void;
}

export const BankDetailsForm = ({ nextStep }: IBankDetailsForm) => {
  const { setRequestsData } = useContext(RequestsContext);
  const isDesktop = useIsDesktop();
  const navigate = useNavigate();

  const formRef = useRef<HTMLFormElement>(null);

  const { bankDetailsForm, setBankNumber, setBranchNumber } =
    useBankDetailsForm();

  useEffect(() => {
    setBankNumber(bankDetailsForm.watch('bankId'));
  }, [bankDetailsForm.watch('bankId'), setBankNumber]);

  useEffect(() => {
    setBranchNumber(bankDetailsForm.watch('branchId'));
  }, [bankDetailsForm.watch('branchId'), setBranchNumber]);

  const onSubmit = async (
    e:
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
      | React.FormEvent<HTMLFormElement>
  ) => {
    e.preventDefault();

    let requestDataJson: IUpdateBankDetails | null = null;
    await bankDetailsForm.handleSubmit((data) => {
      requestDataJson = { ...data };
    })();

    if (Object.keys(bankDetailsForm.formState.errors).length === 0) {
      setRequestsData((prev) => {
        return {
          ...prev,
          requestDataJson,
        };
      });

      nextStep();
    }
  };

  return (
    <>
      <form ref={formRef} onSubmit={onSubmit}>
        <Stack alignItems={'center'}>
          <Stack maxWidth={isDesktop ? '400px' : 'initial'} gap={'24px'}>
            <FormProvider {...bankDetailsForm}>
              <Form />
            </FormProvider>
          </Stack>
        </Stack>
      </form>
      <FormActionButtons
        next={onSubmit}
        previous={() => navigate('/universalRequest')}
      />
    </>
  );
};
